import { Pipe, PipeTransform, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { selectTenantHasEitherFeatureFlags, selectTenantHasFeatureFlag } from '@core/stores/auth/auth.selectors';

import { FeatureFlags } from '@domain/tenant/tenant.enums';

import { AsyncPipeBase } from '../async-pipe-base';

@Pipe({
  name: 'hasFeatureFlags',
  pure: false,
  standalone: true,
})
export class HasFeatureFlagsPipe extends AsyncPipeBase<FeatureFlags | FeatureFlags[], [], boolean> implements PipeTransform {
  readonly #store = inject(Store);
  protected readonly defaultValue = false;

  public transform$(featureFlags: FeatureFlags | FeatureFlags[]): Observable<boolean> {
    return Array.isArray(featureFlags)
      ? this.#store.select(selectTenantHasEitherFeatureFlags(featureFlags))
      : this.#store.select(selectTenantHasFeatureFlag(featureFlags));
  }
}
